/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.viewer.skins.button.LoginButtonSkin'] = {
  "react": [
    [
      "div",
      "container",
      [],
      {},
      [
        "div",
        null,
        [
          "_memberLine"
        ],
        {},
        [
          "div",
          "memberTitle",
          [],
          {}
        ]
      ],
      [
        "div",
        null,
        [
          "_actionLine"
        ],
        {},
        [
          "button",
          "actionTitle",
          [],
          {}
        ]
      ]
    ]
  ],
  "params": {
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "trans": "TRANSITION",
    "txth": "TEXT_COLOR"
  },
  "paramsDefaults": {
    "fnt": "font_7",
    "txt": "color_15",
    "trans": "color 0.4s ease 0s",
    "txth": "color_14"
  },
  "css": {
    "%": "overflow:hidden;text-align:center;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;",
    "%container": "display:inline-block;[fnt]  color:[txt];",
    "%container button": "color:inherit;",
    "%memberTitle": "display:inline-block;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;[trans]",
    "%_actionLine": "display:inline-block;",
    "%actionTitle:hover": "color:[txth];",
    "%actionTitle": "display:inline-block;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;[fnt]  [trans]"
  }
}

    return skins;
});
